// ── a11y helpers ──────────────────────────────────────────────────────────────
// Make a non-button clickable element (a card <div>) keyboard- and screen-reader-
// operable. Spread onto the element in place of a bare onClick:
//   <div {...clickable(() => navigate(`/show/${id}`))} className="tap-card">…</div>
// It exposes role="button" + tabIndex so AT announces it and Tab reaches it, wires
// onClick, and fires the same handler on Enter/Space (with the global :focus-visible
// ring in index.css giving the visible focus state).
export function clickable(onActivate, { label } = {}) {
  return {
    role: 'button',
    tabIndex: 0,
    'aria-label': label,
    onClick: onActivate,
    onKeyDown: (e) => {
      // Guard against a nested real <button> (mark-watched, ⋯ menu, etc — the
      // "nested-interactive" pattern this app still has in several rows,
      // 2026-09-17 audit) bubbling its own Enter/Space keydown up here and
      // firing the ROW's action too. A click on the nested button already
      // stops its own propagation; keydown never did, so keyboard-activating
      // an inner button silently double-fired: e.g. My List's clapboard would
      // both mark the episode AND navigate to the show. Only react when this
      // handler's own element is the actual keydown target.
      if (e.target !== e.currentTarget) return
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onActivate(e) }
    },
  }
}
